import React, { FC } from 'react'
import styled from '@emotion/styled'
import { LinkButton } from 'view/components/buttons'
import { Locale, Translation } from 'locale'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'
import midTradeEventUploadTemplateUrl from '../assets/MidTradeEventUploadTemplate.xlsx'

const MidTradeEventUploadPlaceholderWrapper = styled.div`
  ${mixins.flexCenterContent};
  flex-direction: column;
  color: ${constants.CORE_PRIMARY_6};
`

const PlaceholderNarrative1 = styled.div`
  max-width: 500px;
  font-size: 12px;
  margin: 6px;
`

const DownloadTemplateLink = styled(LinkButton)`
  margin-top: 12px;
`

export const MidTradeEventsGridPlaceholder: FC = () => (
  <MidTradeEventUploadPlaceholderWrapper>
    <PlaceholderNarrative1>{Locale.translate(Translation.SC_MTE_PLACEHOLDER_NARRATIVE)}</PlaceholderNarrative1>
    <DownloadTemplateLink href={midTradeEventUploadTemplateUrl} download={Locale.translate(Translation.TC_DOWNLOAD_MTE_TEMPLATE_FILENAME)}>
      {Locale.translate(Translation.SC_DOWNLOAD_TEMPLATE)}
    </DownloadTemplateLink>
  </MidTradeEventUploadPlaceholderWrapper>
)
